// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2wKQN","row":"styles_row__3FOC7"};